import { call, select, take } from 'redux-saga/effects';

import { configChanged, configLoadDone } from '@pressreader/config';

import { selectArticleFeaturesConfig } from '../../global.selectors';
import { setCopyLegalNoticeEnabled } from '../../utils';

/**
 * Installs and tears down the copy interceptor as the host flag changes.
 *
 * The saga only manages the listener's lifetime — it cannot handle the event itself. `preventDefault`
 * and `clipboardData.setData` are no-ops once the browser has finished dispatching `copy`, so the
 * handler has to run synchronously inside the native dispatch, which an `eventChannel` cannot do.
 */
export function* saga() {
    while (true) {
        const { articleCopyLegalNoticeEnabled }: ReturnType<typeof selectArticleFeaturesConfig> = yield select(selectArticleFeaturesConfig);

        yield call(setCopyLegalNoticeEnabled, articleCopyLegalNoticeEnabled);

        // Both signals, because no single one covers every writer. `loadConfig` dispatches
        // `configLoadDone` then `configChanged`; `extendConfig`, the native adapter's live-update
        // path, dispatches only `configChanged`; and the widgets app boots by dispatching
        // `configLoadDone` on its own and never dispatches `configChanged` at all.
        yield take([configLoadDone, configChanged]);
    }
}
